<template>
  <div class="is-flex is-flex-direction-column is-align-items-center">
    <import-csv
      v-show="showUploadButton"
      label="Import CSV"
      :format="columns"
      :loading="false"
      @submit="submit"
    >
      <template v-if="errorImportMessages.length > 0" #append>
        <div class="control">
          <b-button type="is-danger" icon-left="exclamation-circle" @click="showErrorModal = true">
            {{ errorImportMessages.length }}
          </b-button>
        </div>
      </template>
    </import-csv>

    <b-modal :active="showErrorModal" has-modal-card @close="showErrorModal = false">
      <div class="modal-card">
        <div class="modal-card-head">
          <p class="modal-card-title">Erreurs d'importation</p>
        </div>
        <div class="modal-card-body">
          <b-message
            v-for="(error, index) in errorImportMessages"
            :key="index"
            type="is-danger"
            size="is-small"
            class="m-2"
          >
            {{ error }}
          </b-message>
        </div>
        <div class="modal-card-foot">
          <b-button @click="showErrorModal = false">Fermer</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { getErrorMessages, importLiveVehicleError } from '@helpers/importErrorMessages'
import ImportCsv from '@components/ImportCsv.vue'

const COLUMNS = {
  line: 'line',
  accessType: 'public/private',
  spotTrackerNumber: 'spot',
  queclinkTrackerNumber: 'queclink',
  neyosTrackerNumber: 'neyos',
  number: 'number',
  name: 'name',
  gender: 'gender',
  country: 'country',
  liveCategoryName: 'category',
  phoneNumber: 'phone',
  comment: 'comment',
}

export default {
  name: 'LiveVehicleImportCsv',

  components: {
    ImportCsv,
  },

  props: {
    live: {
      type: Object,
      required: true,
    },
    showUploadButton: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      errorImportMessages: [],
      showErrorModal: false,
    }
  },

  created() {
    this.columns = COLUMNS
  },

  methods: {
    async submit({ result }) {
      this.$emit('submit')
      this.errorImportMessages = []
      this.showErrorModal = false

      const vehicles = result.map((vehicle) => ({
        ...vehicle,
        accessType: vehicle.accessType !== '' ? vehicle.accessType : null,
        spotTrackerNumber: vehicle.spotTrackerNumber !== '' ? vehicle.spotTrackerNumber : null,
        queclinkTrackerNumber:
          vehicle.queclinkTrackerNumber !== '' ? vehicle.queclinkTrackerNumber : null,
        neyosTrackerNumber: vehicle.neyosTrackerNumber !== '' ? vehicle.neyosTrackerNumber : null,
        gender: vehicle.gender !== '' ? vehicle.gender : null,
        country: vehicle.country !== '' ? vehicle.country : null,
        phoneNumber: vehicle.phoneNumber !== '' ? vehicle.phoneNumber : null,
        comment: vehicle.comment !== '' ? vehicle.comment : null,
      }))

      try {
        const liveVehicles = await this.$services.liveVehicleService.saveAll(this.live.id, vehicles)
        this.$emit('done', liveVehicles)
      } catch (err) {
        this.errorImportMessages = getErrorMessages(err, importLiveVehicleError)
        this.$emit('error')
      }
    },
  },
}
</script>
